import {JoinState, JoinActionTypes, ActionTypes, SubmitJoinFulfilledPayload, SubmitJoinRejectedPayload} from './types';

const initialState: JoinState = {
  policyNumber: undefined,
  joinId: undefined,
  submittingJoin: false,
  fetchedJoin: false,
  exceptionMessage: undefined
};

const JoinReducer = (state = initialState, action: JoinActionTypes): JoinState => {
  switch (action.type) {
    case ActionTypes.SUBMIT_JOIN_PENDING: {
      return {
        ...state,
        submittingJoin: true,
        fetchedJoin: false
      };
    }
    case ActionTypes.SUBMIT_JOIN_FULFILLED: {
      const submitFulfilledPayload = action.payload as SubmitJoinFulfilledPayload;

      return {
        ...state,
        policyNumber: submitFulfilledPayload.policyNumber,
        joinId: submitFulfilledPayload.joinId,
        submittingJoin: false,
        fetchedJoin: true
      };
    }
    case ActionTypes.SUBMIT_JOIN_REJECTED: {
      const submitJoinRejectedPayload = action.payload as SubmitJoinRejectedPayload;
      return {
        ...state,
        submittingJoin: false,
        fetchedJoin: true,
        exceptionMessage: submitJoinRejectedPayload.message
      };
    }
    default: {
      return state;
    }
  }
};

export default JoinReducer;
